// extracted by mini-css-extract-plugin
export var badge = "_i0-2";
export var detailsPanel = "_i0-0";
export var resultRow = "_i0-1";